import { render, staticRenderFns } from "./ebudgets-00-drilldown.vue?vue&type=template&id=5a1fa6c0"
import script from "./ebudgets-00-drilldown.vue?vue&type=script&lang=js"
export * from "./ebudgets-00-drilldown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports